<template>
  <ObuShelterListAddDomainDialog
    :show="show"
    :sites="sites"
    @cancel="onClose"
    @confirm="onConfirm"
  />
</template>

<script setup>
import { useProp } from '@/composables/useProp.js'
import { closeDialog } from 'vue3-promise-dialog'
import { ref } from 'vue'
import ObuShelterListAddDomainDialog from './ObuShelterListAddDomainDialog.vue'

defineProps({
  sites: useProp(Array)
})

const show = ref(true)

const onConfirm = value => {
  closeDialog(value)
}

const onClose = () => {
  closeDialog(null)
}

</script>
